var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", { staticClass: "d-block" }, [
        _vm._v("Zusätzliche Empfänger"),
      ]),
      _vm._v(" "),
      _vm.additionalRecipients.length > 0
        ? _c("b-table", {
            ref: "documentTable",
            attrs: { fields: _vm.header, items: _vm.additionalRecipients },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(type)",
                  fn: function (rowData) {
                    return [
                      _c("csp-form-select-searchable", {
                        staticClass: "col-12",
                        staticStyle: { "padding-left": "0" },
                        attrs: { options: _vm.types, value: rowData.item.type },
                        on: {
                          change: function ($event) {
                            return _vm.setAdditionRecipientType(
                              $event,
                              rowData.index
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(name)",
                  fn: function (rowData) {
                    return [
                      _c("b-form-input", {
                        attrs: {
                          name: "additionalRecipientName" + rowData.index,
                        },
                        model: {
                          value: rowData.item.name,
                          callback: function ($$v) {
                            _vm.$set(rowData.item, "name", $$v)
                          },
                          expression: "rowData.item.name",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(mail)",
                  fn: function (rowData) {
                    return [
                      _c("b-form-input", {
                        attrs: {
                          autocomplete: "email",
                          name: "additionalRecipientMail" + rowData.index,
                          required: "",
                        },
                        model: {
                          value: rowData.item.mail,
                          callback: function ($$v) {
                            _vm.$set(rowData.item, "mail", $$v)
                          },
                          expression: "rowData.item.mail",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (rowData) {
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.removeRecipient(rowData.index)
                            },
                          },
                        },
                        [_vm._v("\n                X\n            ")]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              609275098
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-button",
        {
          attrs: { size: "sm", variant: "primary" },
          on: { click: _vm.addAdditionalRecipient },
        },
        [_vm._v("\n        Hinzufügen\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }